import './App.css';
import Navbar from "./pages/Navbar";
import Kontakt from "./pages/Kontakt";
import Home from "./pages/Home";
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Footer from "./pages/Footer";
import SingleProductContainer from "./containers/SingleProductContainer";
import CartContainer from "./containers/CartContainer";
import Tretmani from "./pages/tretmani/Tretmani";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Microneedling from "./pages/info/Microneedling";
import PaymentDetails from "./pages/shop/cart/PaymentDetails";
import Login from "./pages/admin/Login";
import Orders from "./pages/admin/Orders";
import OrderPage from "./pages/admin/OrderPage";
import ErrorBoundary from "./error/ErrorBoundary";
import ScrollToTop from "./hooks/scrollToTop";
import ProductsContainer from "./containers/ProductListContainer";
import BrandProductsPage from "./pages/brands/BrandProductsPage";
import LandingPage from "./pages/shop/home/LandingPage";
import TermsAndConditions from "./pages/info/TermsAndConditions";
import DiscountCodes from "./pages/admin/DiscountCodes";
import EditDiscountCodePage from "./pages/admin/EditDiscountCodePage";

function App() {
    const isAuthenticated = localStorage.getItem("auth") === "true";
    const location = useLocation();
    const isLandingPage = location.pathname === '/';

    return (
        <ErrorBoundary>
            <ScrollToTop />
            {!isLandingPage && <Navbar isAuthenticated={isAuthenticated} />}
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div style={{ flexGrow: "1" }}>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/shop/brands/:brandName" element={<BrandProductsPage />} />
                        <Route path="shop/cart" element={<CartContainer />} />
                        <Route path="shop/:productId" element={<SingleProductContainer />} />
                        <Route path="shop/" element={<ProductsContainer />} isAuthenticated={isAuthenticated} />
                        <Route path="kontakt/" element={<Kontakt />} />
                        <Route path="cart/" element={<CartContainer />} />
                        <Route path="tretmani/microneedling/" element={<Microneedling />} />
                        <Route path="tretmani/" element={<Tretmani />} />
                        <Route path="narudzbe/:orderId" element={<OrderPage />} />
                        <Route path="narudzbe/" element={<Orders />} />
                        <Route path="payment/" element={<PaymentDetails />} />
                        <Route path="admin/login" element={<Login />} />
                        <Route path="/admin/discounts" element={<DiscountCodes />} />
                        <Route path="/admin/discounts/:id" element={<EditDiscountCodePage />} />
                        <Route path="/uvjeti-korištenja" element={<TermsAndConditions />} />
                    </Routes>
                </div>
                {!isLandingPage && <Footer />}
            </div>
        </ErrorBoundary>
    );
}

export default App;
